import {
  type AllocationBE,
  getEntitySubAccountNames,
  type IAllocation,
  type LPSettlementEventTypeEnum,
  type TradeSettleStatusEnum,
  type TransactionControlTypeEnum,
} from '@talos/kyoko';
import type { LPSettlementReport } from '../../types';
import { lpSettlementDealId, lpSettlementOrderId } from '../../utils/lpSettlementParentEventIds';
import { lpSettlementTradeId } from '../../utils/lpSettlementTradeId';

export type LPSettlementReportBlotterRow = TradeRow;

export function lpSettlementReportBlotterRow(row: LPSettlementReport): LPSettlementReportBlotterRow[] {
  const tradeRow = new TradeRow(row);

  return [tradeRow];
}

export class TradeRow {
  report: LPSettlementReport;
  RowID: string;
  EventID: string;
  TradeID: string;
  EventExternalID: string;
  OrderID: string;
  DealID: string;
  TransactionType: TransactionControlTypeEnum;
  EventType: LPSettlementEventTypeEnum;
  MarketAccount: string;
  Counterparty: string;
  Allocation: IAllocation | undefined;
  SettleStatus: TradeSettleStatusEnum;
  SettleDeadline: string;
  EventTransactTime: string;
  EventSide: string;
  EventPrice?: string;
  BaseLeg: LPSettlementReport['BaseLeg'];
  QuoteLeg: LPSettlementReport['QuoteLeg'];
  Revision: number;
  TradeDateEOD?: string;
  subAccounts: string[] | undefined;

  constructor(row: LPSettlementReport) {
    this.report = row;
    this.RowID = `${row.EventID}`;
    this.EventID = row.EventID;
    this.TradeID = lpSettlementTradeId(row);
    this.EventExternalID = row.EventExternalID ?? '';
    this.OrderID = lpSettlementOrderId(row);
    this.DealID = lpSettlementDealId(row);
    this.TransactionType = row.TransactionType;
    this.EventType = row.EventType;
    this.MarketAccount = row.MarketAccount;
    this.Counterparty = row.Counterparty;

    this.Allocation = row.Allocation;
    this.SettleStatus = row.SettleStatus;
    this.SettleDeadline = row.SettleDeadline;
    this.EventTransactTime = row.EventTransactTime;
    this.EventSide = row.EventSide;
    this.EventPrice = row.EventPrice;
    this.BaseLeg = row.BaseLeg;
    this.QuoteLeg = row.QuoteLeg;
    this.Revision = row.Revision;
    this.TradeDateEOD = row.TradeDateEOD;

    this.subAccounts = getEntitySubAccountNames({
      SubAccount: row.SubAccount,
      Allocation: row.Allocation as AllocationBE,
    });
  }
}
